import React from 'react'
import { priceNotation } from '../../../utils/safe'

const ImportoCard = ({ title, importo }) => {
  return (
    <div className="importo_container">
      <div className="importo__card">
        <div className="importo__card__description">
          <div className="importo__card__title">
            <strong>{title}</strong>
          </div>
          <div className="importo__card__cifra">
            <strong>{priceNotation(importo, 2)} €</strong>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImportoCard
